import React from 'react'
import { useLocation } from 'react-router-dom'
import { sellerApi } from 'api/seller'

const MIN_INTERVAL_MS = 60 * 1000
const ACTION_EVENTS = ['pointerdown', 'keydown'] as const

// «Последняя активность» продавца — действия в кабинете, а не вход по паролю: сессия живёт
// месяцами. Только при видимой вкладке: восстановленная браузером в фоне не считается
export const useCabinetActivity = (isEnabled: boolean) => {
  const { pathname } = useLocation()
  const lastSentAt = React.useRef(0)

  const send = React.useCallback(() => {
    if (document.visibilityState !== 'visible') return
    if (Date.now() - lastSentAt.current < MIN_INTERVAL_MS) return

    lastSentAt.current = Date.now()
    sellerApi.markCabinetActivity().catch(() => undefined)
  }, [])

  React.useEffect(() => {
    if (isEnabled) send()
  }, [isEnabled, pathname, send])

  React.useEffect(() => {
    if (!isEnabled) return

    const options = { capture: true, passive: true }
    document.addEventListener('visibilitychange', send)
    ACTION_EVENTS.forEach((event) =>
      document.addEventListener(event, send, options)
    )
    return () => {
      document.removeEventListener('visibilitychange', send)
      ACTION_EVENTS.forEach((event) =>
        document.removeEventListener(event, send, options)
      )
    }
  }, [isEnabled, send])
}
